import { useMemo } from 'react';
/**
 * iteratorのindex参照エラーを回避するarrayを返すためのuse
 * @description 主にSkeletonのダミーデータ作成などに利用してください
 * @param count
 * @returns {{index}[]}
 */
export const useArrayWithIndex = (count) => useMemo(() => [...Array(count)].map((_, i) => ({ index: i })), [count]);
